module.exports = __webpack_public_path__ + "img/school_hkjz.e886bf82.png";